import turfBooleanDisjoint from '@turf/boolean-disjoint';
import { Feature, FeatureCollection, Point } from 'geojson';
import transform from 'geojson-transformer';
import { fetchData, IParkingLotAmendMentPoint } from '../../api/record/parkingLotAmendment';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';
import PolygonsLoader from './PolygonsLoader';

const polygonsLoader = new PolygonsLoader();

export default class ParkPointLoader extends SingletonEventEmitterClass {
  public geojsonUser: FeatureCollection<Point> = {
    type: 'FeatureCollection',
    features: [],
  };

  public geojsonStock: FeatureCollection<Point> = {
    type: 'FeatureCollection',
    features: [],
  };

  public days: number = 1;
  private _regionId: string | undefined;

  // private _data: IParkingLotAmendMentPoint[] = [];
  private get _data(): IParkingLotAmendMentPoint[] {
    return this.__data.reduce((memo, item) => {
      memo.push(...item);
      return memo;
    }, []);
  }

  private __data: IParkingLotAmendMentPoint[][] = [];

  public changeDays(days: number) {
    this.days = days;
    this.fetchByRegion();
  }

  public fetchByRegion(regionId?: string) {
    if (regionId) {
      this._regionId = regionId;
    }
    (async () => {
      if (!this._regionId) {
        return;
      }
      this.__data = [];
      await Promise.all(new Array(this.days).fill('').map(async (stuff, i) => {
        this.__data.push(await fetchData(this._regionId!, Date.now() - (24 * 3600000 * i)));
      }));
      this._generateGeoJSON();
    })().catch(() => {
      // noop.
    });
  }

  public disjointPoints(callbacks: { onStart: (total: number) => void, onProcess: (count: number) => void, onFinish: (rest: number) => void }) {
    this._generateGeoJSON(callbacks);
  }

  private _generateGeoJSON(callbacks?: { onStart: (total: number) => void, onProcess: (count: number) => void, onFinish: (rest: number) => void }) {
    if (callbacks) {
      callbacks.onStart(this._data.length);
    }
    process.nextTick(() => {
      let count = 0;
      this.geojsonUser.features = [];
      this.geojsonStock.features = [];
      const polygons = {
        type: 'MultiPolygon',
        coordinates: polygonsLoader.geojsonRemotePolygonsBuffer.features.map(feature => {
          return feature.geometry.coordinates;
        }),
      };
      const dataCopy = [...this._data];
      const timer = setInterval(() => {
        const rows = dataCopy.splice(0, 100);
        if (rows.length === 0) {
          this._triggerUpdate();
          if (callbacks) {
            callbacks.onFinish(this.geojsonUser.features.length);
          }
          clearInterval(timer);
          return;
        }
        rows.forEach(row => {
          const userPoint = transform(row.user.lngLat, 'gcj02', 'wgs84');
          const stockPoint = transform(row.stock.lngLat, 'gcj02', 'wgs84');
          const points = {
            type: 'MultiPoint',
            coordinates: [
              userPoint,
              stockPoint,
            ],
          };
          if (turfBooleanDisjoint(polygons, points)) {
            this.geojsonUser.features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: userPoint,
              },
              properties: {},
            });
            this.geojsonStock.features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: stockPoint,
              },
              properties: {},
            });
          }
        });
        count += rows.length;
        if (callbacks) {
          callbacks.onProcess(count);
        }
      }, 1);
    });
  }

  private _triggerUpdate() {
    this.emit('updated');
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/ParkPointLoader.ts